import React,{useState,useEffect,useRef} from "react";

import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import {ChevronUp,ChevronDown,
  GripHorizontal,Film,
  
  Pencil,
 } from 'lucide-react';
import { addEntityToAnyEntity, createNewChapter} from "../../../store/actions/CreateContent/FolderAPI/ChapterAPI";

import contentfolder from "../../contentImgs/folder.png";
import BatchFolderContent from "./BatchFolderContent";
import BatchLeftPopup from "./BatchLeftPopup";
import { getDripItem } from "./getDripItem";
import DripItemFields from "./DripItemFields";
const BatchSections =({mileStoneSectionSend,mileStoneItemSend,selectCoursePopUp,setCreateNewMileStone,index,contentDripArr})=>{

     const dispatch = useDispatch();
         const user = useSelector((state)=>state?.user?.user);
               const [activeFilterOne, setActiveFilterOne] =useState(true);
                       const [activeFilterTwo, setActiveFilterTwo] =useState(true);
                       const [activeFilterThree, setActiveFilterThree] =useState(false);
                       const [activeFilterFour, setActiveFilterFour] =useState(false);
                       const [activeFilterASC, setActiveFilterASC] =useState(true);
                       const [activeFilterDESC, setActiveFilterDESC] =useState(false);
                      const [currentDripItemStatus,setCurrentDripItemStatus]=useState(true)
         const [snackbarVisible, setSnackbarVisible] = useState(false);
                          const [snackbarColor, setSnackbarColor] = useState("#958FDA");
                          const [responseMessage, setResponseMessage] =useState("Something Went Wrong!!!");
                    
                                  const mainMenuStatus = useSelector((state)=>state?.app?.mainMenuStatus);
                       const showSnackbar = () => {
                         setSnackbarVisible(true);
                       };
                      
                       const hideSnackbar = () => {
                         setSnackbarVisible(false);
                       };
                 
                 
                            
                            
                         
                        const [animate, setAnimate] = useState(false);
          
                            const [loader , setLoader] =useState({status:false});
    const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
        {
          
          dispatch({type: "CURSOR",payload:true  });
      
          dispatch({type: "CURSORTEXT",payload:CursorText})
          dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
          dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
        }
         
        const handleMouseLeave = () => {
          
          dispatch({type: "CURSOR",payload:false})
      
          dispatch({type: "CURSORTEXT",payload:""})
      
          dispatch({type: "CURSORTEXTBG",payload:""})
          dispatch({type: "CURSORTEXTCOLOR",payload:""})
        
      
      }
      const [openAppDesignPopUp,setopenAppDesignPopUp]  = useState(false);
      const [openAppDesignPopUpInnerContent,setopenAppDesignPopUpInnerContent]  = useState("appThemes");

                 const [currentItem, setCurrentItem] = useState("");
                 const [currentDripItem, setCurrentDripItem] = useState("");
const token = useSelector((state)=>state?.course?.course?.token);
       const currentToken = useSelector((state)=>state?.user?.user?.token);
       const user_email = useSelector((state)=>state?.user?.user?.user_email
      );
      
      const postIdCourse = useSelector((state)=>state?.course?.course?.postId);
      
      const courseData = useSelector((state)=>state?.course?.course);
      
      const AppToken = useSelector((state)=>state?.app?.app?.AppToken);
        const appId = useSelector((state)=>state?.app?.app?.ID);
                       const appAllottedToken = useSelector((state)=>state?.app?.app?.appAllottedToken);
     
           const [visibility,setVisibility] =useState("public");
           const [orderBy,setOrderBy] =useState("ASC");
           const [itemArr, setItemArr] = useState([]);
           const [itemReorderArr, setItemReorderArr] = useState([]);
           const [itemId, setItemId] = useState("");
           const [itemChapterId, setItemChapterId] = useState("");
            const [deleteItemPopUp, setDeleteItemPopUp] = useState(false);
            
             const [newFolderInSectionPopUp ,setNewFolderInSectionPopUp] =useState(false);
              const [currentChapterID ,setCurrentChapterId] =useState("");
                        const [deleteItemChapterPopUp, setDeleteItemChapterPopUp] = useState(false);
           const [deleteSubCoursePopUp, setDeleteSubCoursePopUp] = useState(false);
           const [itemArrLoading, setItemArrLoading] = useState([{},{},{},{},{}]);
           const [itemArrChapter, setItemArrChapter] = useState([]);
           const [itemArrChapterInn, setItemArrChapterInn] = useState([]);
           const [itemArrLoadingChapter, setItemArrLoadingChapter] = useState([{},{},{},{},{}]);
          
           const [openContentInFolder, setOpenContentInFolder] = useState("");
           const [createNewChapterPopUp ,setCreateNewChapterPopUp]= useState("");
           
            const [newFolderInChapterPopUp ,setNewFolderInChapterPopUp] =useState(false);
            const [chapterItem ,setChapterItem] =useState({});
 const [sectionItem ,setSectionItem] =useState({});
 const [mileStoneItem ,setMileStoneItem] =useState(mileStoneItemSend);
 const [mileStoneSection ,setMileStoneSection] =useState(mileStoneSectionSend);
 const [sectionID ,setSectionID] =useState("");
      const [sectionMenuOrder ,setSectionMenuOrder] =useState("");
    
      const [currentEntityID ,setCurrentEntityId] =useState("");
      const [currentFolder ,setCurrentFolder] =useState();
     const [newChapterPopUp ,setNewChapterPopUp] =useState(false);
 const [newSectionPopUp ,setNewSectionPopUp] =useState(false);
 const [openFolderContentPopUp ,setOpenFolderContentPopUp] =useState(false);




useEffect((e)=>{
    setMileStoneItem(mileStoneItemSend)
    setMileStoneSection(mileStoneSectionSend)
    
    },[mileStoneItemSend,mileStoneSectionSend,]);
      useEffect((e)=>{
      
        fireGetAllSectionsByMileStoneId();
        },[visibility,orderBy,postIdCourse,mileStoneSectionSend?.ID]);
  const fireGetAllSectionsByMileStoneId=()=>{
          setItemArr([])
         
        
          setItemArrLoading([{},{},{},{},{}])
        // Popup When Course is not selected
          if(courseData){}else{selectCoursePopUp(true);}
        
        setLoader({status:true});
            // console.log({
            //     token:AppToken,courseId:postIdCourse ,postParent:mileStoneSectionSend?.ID,userEmail:user_email?user_email:"",currentToken:currentToken?currentToken:"",
            //     appToken:AppToken,visibility:visibility,orderBy:orderBy
            //     });
            
              const apiData = dispatch(addEntityToAnyEntity({
                token:AppToken,courseId:postIdCourse ,parentEntityType:"Milestone",parentEntityId:mileStoneSectionSend?.ID,postParent:mileStoneSectionSend?.ID,userEmail:user_email?user_email:"",currentToken:currentToken?currentToken:"",
                appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken,visibility:visibility,orderBy:orderBy,editType:"getAllContents",
                }));
              /* get response as Promise   */
              apiData.then(response => {
                // console.log(response)
        
                if(response){
                 
                  if(response){
                setResponseMessage(response?.message);
                setSnackbarColor("rgba(144, 202, 249,1)");
              
                if(response)  {setItemArr(response?.contents);
                  
                  setMileStoneSection(response?.contents[0])
                  setItemId(response?.contents[0]?.contentID);fireGetAllChaptersBySectionId(response?.contents[0]?.contentID);
                   fireGetAllContentssByChapterId(response?.contents[0]?.contentID);setCurrentChapterId(response?.contents[0]?.contentID);setOpenContentInFolder(true)
                  if(setCreateNewMileStone){setVisibility('public');setopenAppDesignPopUp(true);setopenAppDesignPopUpInnerContent("createMileStone");}
      
                  const reorderArray = response?.contents.map(item => ({
                    ID: item.ID,
                    menuOrder: item.menuOrder
                }));
                setItemReorderArr(reorderArray);
                //  console.log(reorderArray)
               
                }else{setItemArr([]);};
                setItemArrLoading([]);
            setLoader({status:false});
            
            // setSnackbarVisible(true);
            setTimeout(()=>{
              
              setSnackbarVisible(false);
            },1000)
               }else{
            //     setResponseMessage("Something Went Wrong...");
                  
            //     setSnackbarColor("#958FDA");
            //   //  selectCoursePopUp(true);
                
                 
            // setLoader({status:false});
            // setItemArrLoading([{},{},{},{},{}]);
            setSnackbarVisible(true);
            setTimeout(()=>{
              
              setSnackbarVisible(false);
             
               
            },3000)
               }
                  
                // dispatch({
                //   type: "UPDATE_APP_TOKEN",
                  
                //   payload:response?.course?.AppToken
                // });  
              //  console.log(response?.course);
             
               // 
               if(response?.logout){
                // pop up response?.logoutInfo
                //console.log(response?.logoutInfo)
            
                setResponseMessage("You are Logged Out!!!");
                  
                setSnackbarColor("#958FDA");
               selectCoursePopUp(true);
                
                 
            setLoader({status:false});
            
            setSnackbarVisible(true);
            setTimeout(()=>{
              
              setSnackbarVisible(false);
             
               
            },3000)
                setTimeout(()=>{
                  dispatch({type:"LOGOUT"});
            
                },3000)
                
              }
            /* resetting Login input Fields */
            
                }else{
                  setResponseMessage("Something Went Wrong...");
                  
                  setSnackbarColor("#958FDA");
                 selectCoursePopUp(true);
                 setItemArrLoading([{},{},{},{},{}]);
                   
              setLoader({status:false});
              
              setSnackbarVisible(true);
              setTimeout(()=>{
                
                setSnackbarVisible(false);
               
                 
              },3000)    }
            
              }).catch(error => {
             
                //popup of error Info
                setResponseMessage("Something Went Wrong...");
                  
                setSnackbarColor("#958FDA");
               selectCoursePopUp(true);
                
                 
            setLoader({status:false});
            
            setSnackbarVisible(true);
            setTimeout(()=>{
              
              setSnackbarVisible(false);
             
               
            },3000)
                console.error(error);
              });
         }
  const fireGetAllContentssByChapterId=(ChapterIDVal)=>{
          setItemArrChapterInn([])
         
        
        // Popup When Course is not selected
          if(courseData){}else{selectCoursePopUp(true);}
        
        setLoader({status:true});
           
              const apiData = dispatch(addEntityToAnyEntity({
               courseId:postIdCourse ,parentEntityType:"chapter",parentEntityId:ChapterIDVal,userEmail:user_email?user_email:"",currentToken:currentToken?currentToken:"",
                appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken,visibility:visibility,orderBy:orderBy,
                editType:"getAllContents",
                }));
              /* get response as Promise   */
              apiData.then(response => {
                // console.log(response)
        
                if(response){
                 
                  if(response?.contents){
                setResponseMessage(response?.message);
                setSnackbarColor("rgba(144, 202, 249,1)");
              
                if(response?.contents)  {setItemArrChapterInn(response?.contents); 
                  
                    //  console.log(reorderArray)
               
                }else{setItemArrChapterInn([]);};
                
            setLoader({status:false});
            
            // setSnackbarVisible(true);
            setTimeout(()=>{
              
              setSnackbarVisible(false);
            },1000)
               }else{
            
            setSnackbarVisible(true);
            setTimeout(()=>{
              
              setSnackbarVisible(false);
             
               
            },3000)
               }
                  
                
               if(response?.logout){
                // pop up response?.logoutInfo
                //console.log(response?.logoutInfo)
            
                setResponseMessage("You are Logged Out!!!");
                  
                setSnackbarColor("#958FDA");
               selectCoursePopUp(true);
                
                 
            setLoader({status:false});
            
            setSnackbarVisible(true);
            setTimeout(()=>{
              
              setSnackbarVisible(false);
             
               
            },3000)
                setTimeout(()=>{
                  dispatch({type:"LOGOUT"});
            
                },3000)
                
              }
            /* resetting Login input Fields */
            
                }else{
                  setResponseMessage("Something Went Wrong...");
                  
                  setSnackbarColor("#958FDA");
                 selectCoursePopUp(true);
                 setItemArrLoading([{},{},{},{},{}]);
                   
              setLoader({status:false});
              
              setSnackbarVisible(true);
              setTimeout(()=>{
                
                setSnackbarVisible(false);
               
                 
              },3000)    }
            
              }).catch(error => {
             
                //popup of error Info
                setResponseMessage("Something Went Wrong...");
                  
                setSnackbarColor("#958FDA");
               selectCoursePopUp(true);
                
                 
            setLoader({status:false});
            
            setSnackbarVisible(true);
            setTimeout(()=>{
              
              setSnackbarVisible(false);
             
               
            },3000)
                console.error(error);
              });
         }

 


         const flattenedData = itemArr!=[]?Object.values(itemArr):'';

         const flattenedDataLoading = itemArrLoading!=[]?Object.values(itemArrLoading):'';
 
const setArrayItemsChapter=(chapterArray)=>{
    setItemArrChapter(chapterArray);
}


 const fireGetAllChaptersBySectionId=(sectionId)=>{
    setItemArrChapter([]);
   
  
    setItemArrLoadingChapter([{},{},{},{},{}])
  // Popup When Course is not selected
    
  setLoader({status:true});
      // console.log({
      //     token:AppToken,courseId:postIdCourse ,postParent:justSectionSend?.ID,userEmail:user_email?user_email:"",currentToken:currentToken?currentToken:"",
      //     appToken:AppToken,visibility:visibility,orderBy:orderBy
      //     });
        const apiData = dispatch(addEntityToAnyEntity({
                       courseId:postIdCourse ,parentEntityType:"section",parentEntityId:sectionId,userEmail:user_email?user_email:"",currentToken:currentToken?currentToken:"",
                        appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken,visibility:visibility,orderBy:orderBy,
                        editType:"getAllContents",
                        }));
        /* get response as Promise   */
        apiData.then(response => {
          // console.log(response)
  
          if(response){
           
            if(response){
          setResponseMessage(response?.message);
          setSnackbarColor("rgba(144, 202, 249,1)");
        
          if(response?.contents)  {setItemArrChapter(response?.contents); 
            
          
        
          //  console.log(reorderArray)
         
          }else{setItemArrChapter([]);};
          setItemArrLoadingChapter([]);
      setLoader({status:false});
      
      // setSnackbarVisible(true);
      setTimeout(()=>{
        
        setSnackbarVisible(false);
      },1000)
         }else{
      //     setResponseMessage("Something Went Wrong...");
            
      //     setSnackbarColor("#958FDA");
      //   //  selectCoursePopUp(true);
          
           
      // setLoader({status:false});
      // setItemArrLoading([{},{},{},{},{}]);
      setSnackbarVisible(true);
      setTimeout(()=>{
        
        setSnackbarVisible(false);
       
         
      },3000)
         }
            
          // dispatch({
          //   type: "UPDATE_APP_TOKEN",
            
          //   payload:response?.course?.AppToken
          // });  
        //  console.log(response?.course);
       
         // 
         if(response?.logout){
          // pop up response?.logoutInfo
          //console.log(response?.logoutInfo)
      
          setResponseMessage("You are Logged Out!!!");
            
          setSnackbarColor("#958FDA");
         selectCoursePopUp(true);
          
           
      setLoader({status:false});
      
      setSnackbarVisible(true);
      setTimeout(()=>{
        
        setSnackbarVisible(false);
       
         
      },3000)
          setTimeout(()=>{
            dispatch({type:"LOGOUT"});
      
          },3000)
          
        }
      /* resetting Login input Fields */
      
          }else{
            setResponseMessage("Something Went Wrong...");
            
            setSnackbarColor("#958FDA");
           selectCoursePopUp(true);
           setItemArrLoadingChapter([{},{},{},{},{}]);
             
        setLoader({status:false});
        
        setSnackbarVisible(true);
        setTimeout(()=>{
          
          setSnackbarVisible(false);
         
           
        },3000)    }
      
        }).catch(error => {
       
          //popup of error Info
          setResponseMessage("Something Went Wrong...");
            
          setSnackbarColor("#958FDA");
         selectCoursePopUp(true);
          
           
      setLoader({status:false});
      
      setSnackbarVisible(true);
      setTimeout(()=>{
        
        setSnackbarVisible(false);
       
         
      },3000)
          console.error(error);
        });
   }

         const handleDeleteChapter=(val,chapterIDK)=>{
           let editType=val;
             
           setLoader({status:true});
         
                 const apiData = dispatch( createNewChapter({
                               token:token,courseId:postIdCourse ,postParent:sectionItem?.ID ,userEmail:user_email?user_email:null,
                               currentToken:currentToken?currentToken:null,appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken,
                               editType:editType,postId:chapterIDK,menuOrder:1}));
              
             /* get response as Promise   */
             apiData.then(response => {
               if(response){
         
                //  console.log(response)
                 if(response?.chapter){
               setResponseMessage(response?.message);
               setSnackbarColor("rgba(144, 202, 249,1)");
             
                
           setLoader({status:false});
           
           setSnackbarVisible(true);
           setTimeout(()=>{
             
             setSnackbarVisible(false);
            
            if(val=="deleteChapter"){
             // setActiveFilterTwo(false);;setActiveFilterThree(true);
             const removedItems = itemArrChapter.filter(item => item?.ID !== response?.chapter?.ID);
           
             
          setArrayItemsChapter(removedItems)
            } 
             
           },1000)
              }else{
               setResponseMessage("Something Went Wrong...");
                 
               setSnackbarColor("#958FDA");
            
                
           setLoader({status:false});
           
           setSnackbarVisible(true);
           setTimeout(()=>{
             
             setSnackbarVisible(false);
            
              
           },3000)
              }
                 
              
              if(response?.logout){
              
               setResponseMessage("You are Logged Out!!!");
                 
               setSnackbarColor("#958FDA");
            
                
           setLoader({status:false});
           
           setSnackbarVisible(true);
           setTimeout(()=>{
             
             setSnackbarVisible(false);
            
              
           },3000)
               setTimeout(()=>{
                 dispatch({type:"LOGOUT"});
           
               },3000)
               
             }
           /* resetting Login input Fields */
           
               }else{
                 setResponseMessage("Something Went Wrong...");
                 
                 setSnackbarColor("#958FDA");
              
                  
             setLoader({status:false});
             
             setSnackbarVisible(true);
             setTimeout(()=>{
               
               setSnackbarVisible(false);
              
                
             },3000)    }
           
             }).catch(error => {
            
               //popup of error Info
               setResponseMessage("Something Went Wrong...");
                 
               setSnackbarColor("#958FDA");
            
                
           setLoader({status:false});
           
           setSnackbarVisible(true);
           setTimeout(()=>{
             
             setSnackbarVisible(false);
            
              
           },3000)
               console.error(error);
             });
            
             }


             
   const flattenedDataChapter = itemArrChapter!=[]?Object.values(itemArrChapter):'';

   const flattenedDataLoadingChapter = itemArrLoadingChapter!=[]?Object.values(itemArrLoadingChapter):'';

   const flattenedDataChapterInn = itemArrChapterInn!=[]?Object.values(itemArrChapterInn):'';
    return (<>
       
        <div  align="left" className=""  >


    
              <div className="gridForWhatsNextAfterSections"   >
            <div   style={{}}>
            <h3 align="left">{flattenedData?.length?"Showing " 
             +(flattenedData?.length):"No Content Found"}
              {activeFilterTwo?flattenedData?.length>1?" Items"
             :flattenedData?.length?" Item":"":""} in Milestone {index+1}
              
              </h3>
            {flattenedDataLoading?.length==0?flattenedData?.length?flattenedData?.map((item, index) => 
        (<div  index={index} key={item?.ID}  style={{border:"2px dashed rgba(144, 202, 249,0.4)",borderRadius:"10px",padding:"2px 10px",margin:"3px",marginBottom:"10px",background:"#ffffff"}}  >
            

{item?.postType=="chapter"||item?.postType=="folder"?
<div  index={index} key={item?.ID} style={{margin:"0px",marginTop:"10px",padding:"10px",paddingLeft:"0px",background:"#ffffff"}}   >
{<div  style={{height:"19px",
            zIndex:"99", top:"0px",}} 
          className="product-tag-theme1">  <div  
          color="#666666" align="center" style={{padding:"4px",float:"left",width:"10px",height:"10px",
          background:"#ffffff",color:"#222",borderRadius:"15px",cursor:"pointer",cursor: 'move',marginRight:"10px"}}>{index+1}</div>{item?.postType=="chapter"? "Chapter":item?.postType=="folder"?"Folder":""}  </div>}<div  className="courseContentItemOuterHeadActiveSettings" style={{margin:"10px",marginTop:"0px",padding:"10px",paddingLeft:"10px",background:"#ffffff"}} >
<div className="courseContentItemJustifyContentIcons">{ item?.postType=="folder"?<img     src={contentfolder} 
        alt="selected Img"
   style={{cursor:"pointer",width:"25px",height:"25px"
    
   }}/>:visibility=="public"?
   item?.postType=="chapter"?<Film  onMouseEnter={handleMouseEnter}
             onMouseLeave={handleMouseLeave} strokeWidth={2} absoluteStrokeWidth  size={18} 
   color="rgba(144, 202, 249,1)" style={{padding:"5px",background:"rgba(144, 202, 249,0.1)",borderRadius:"5px",cursor:"pointer",cursor: 'move',}}/> :<div></div>:<div></div>}
   
 </div><div className="courseContentItemJustifyContent"> <div className="themeNone "
 style={{fontSize:"15px",color:"#111",fontWeight:"700"}}> 
  {index+1}:  {item?.postType=="folder"?"Folder":item?.postType=="chapter"?"Chapter ":""} -  {item?.Name}
 <div>
 <DripItemFields drip={getDripItem(item?.ID, contentDripArr)} />
 </div>
      </div></div><div  className="courseContentItemOuterHeadActiveSettingsInnTwo"
         style={{fontSize:"10px",color:"#222",fontWeight:"800"}}>
            
 <div  style={{padding:"5px",background:"rgba(144, 202, 249,0.1)",fontSize:"14px",padding:"5px 10px",display:"flex",
            justifyContent:"center",alignItems:"center",gap:"5px",
                borderRadius:"5px",cursor:"pointer"}} onClick={()=>{setCurrentItem(item);setCurrentDripItem(getDripItem(item?.ID, contentDripArr));
                                setCurrentDripItemStatus(true)}}>{getDripItem(item?.ID, contentDripArr)?<span className="hideXsForApp">Update  </span>:<span className="hideXsForApp">Add  </span>} Drip</div>  
    
        
         </div>
         {currentChapterID==item?.contentID?<div onClick={()=>{ fireGetAllContentssByChapterId(itemArr?.contentID);setCurrentChapterId("");;setOpenContentInFolder(false)}}
          style={{width:"50px",marginLeft:"-10px",marginRight:"-20px",background:"#ffffff",display:"flex",padding:"5px",borderRadius:"5px",justifyContent:"space-between",alignItems:"center",cursor:"pointer"}}>Close<ChevronUp 
            onMouseEnter={handleMouseEnter}
           onMouseLeave={handleMouseLeave} strokeWidth={2} absoluteStrokeWidth  size={18}  color="rgba(255,114,94,0.7)" style={{padding:"2px",cursor:"pointer"}}/> 
         </div>  :<div onClick={()=>{
               fireGetAllContentssByChapterId(item?.contentID);setCurrentChapterId(item?.contentID);setOpenContentInFolder(true)
             }} style={{width:"50px",marginLeft:"-10px",background:"#ffffff",display:"flex",padding:"5px",borderRadius:"5px",cursor:"pointer",
         justifyContent:"space-between",alignItems:"center"}}>Open<ChevronDown   onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave} strokeWidth={2} absoluteStrokeWidth  size={18}  color="rgba(255,114,94,0.7)" style={{padding:"2px",cursor:"pointer"}}/> 
           </div>} 
            
      
 </div>
 
 <div  >
  </div>{item?.postType=="chapter"?currentChapterID==item?.contentID?flattenedDataChapterInn?.length?flattenedDataChapterInn?.map((itemFF, indexFF) => 
        (<div  index={indexFF} key={itemFF?.ID}    > 
     <BatchFolderContent contentDripArr={contentDripArr} item={itemFF} closePopUp={()=>{ setOpenFolderContentPopUp(false)}} />
    </div>)):"":"":""}  </div>



:item?.postType=="section"?<>
            <div style={{}}

            >
          {<div  style={{height:"19px",
            zIndex:"99", top:"0px",}} 
          className="product-tag-theme1">  <div  
          color="#666666" align="center" style={{padding:"4px",float:"left",width:"10px",height:"10px",
          background:"#ffffff",color:"#222",borderRadius:"15px",cursor:"pointer",cursor: 'move',marginRight:"10px"}}>{index+1}</div>{item?.postType=="section"? "Section":item?.postType=="folder"?"Folder":""}  </div>}
            <div  className="courseContentItemOuterHeadActiveSettings" style={{margin:"10px",marginTop:"0px",padding:"10px",paddingLeft:"10px",background:"transparent"}}>
<div className="courseContentItemJustifyContentIcons">{visibility=="public"?<GripHorizontal  onMouseEnter={handleMouseEnter}
           onMouseLeave={handleMouseLeave} strokeWidth={2} absoluteStrokeWidth  size={18} 
 color="rgba(144, 202, 249,1)" style={{padding:"4px",background:"#ffffff",border:"2px solid rgba(144, 202, 249,1)",borderRadius:"5px",cursor:"pointer",cursor: 'move',}}/> :<div></div>}
 </div><div className="courseContentItemJustifyContent" style={{display:"flex",justifyContent:"left"}}> { item?.postType=="folder"?<img     src={contentfolder} 
        alt="selected Img"
   style={{cursor:"pointer",width:"35px",height:"35px",marginLeft:"10px"
    
   }}/>:""}<div className="themeNone "
 style={{fontSize:"15px",color:"#111",fontWeight:"700"}}> 
 
   
  
 {index+1}:  {item?.Name}
 
      </div>
      <div>
      <DripItemFields drip={getDripItem(item?.ID, contentDripArr)} />
      </div></div><div  className="courseContentItemOuterHeadActiveSettingsInnTwo"
 style={{fontSize:"10px",color:"#222",fontWeight:"800"}}>
  
           <div  style={{padding:"5px",background:"rgba(144, 202, 249,0.1)",fontSize:"14px",padding:"5px 10px",display:"flex",
            justifyContent:"center",alignItems:"center",gap:"5px",
                borderRadius:"5px",cursor:"pointer"}} onClick={()=>{setCurrentItem(item);setCurrentDripItem(getDripItem(item?.ID, contentDripArr));
                                setCurrentDripItemStatus(true)}}>{getDripItem(item?.ID, contentDripArr)?<span className="hideXsForApp">Update  </span>:<span className="hideXsForApp">Add  </span>} Drip</div>  
 </div>
  {item?.postType=="section"?itemId==item?.contentID&&flattenedDataChapter?.length?
 <div  onClick={()=>{ setItemId("");}}
          style={{width:"50px",marginLeft:"-10px",background:"#ffffff",display:"flex",padding:"5px",borderRadius:"5px",justifyContent:"space-between",alignItems:"center",cursor:"pointer"}}>Close<ChevronUp 
            onMouseEnter={handleMouseEnter}
           onMouseLeave={handleMouseLeave} strokeWidth={2} absoluteStrokeWidth  size={18}  color="rgba(255,114,94,0.7)" style={{padding:"2px",cursor:"pointer"}}/> 
         </div> :<div onClick={()=>{setItemId(item?.contentID);fireGetAllChaptersBySectionId(item?.contentID);
   
  }}  style={{width:"50px",marginLeft:"-10px",background:"#ffffff",display:"flex",padding:"5px",borderRadius:"5px",cursor:"pointer",
         justifyContent:"space-between",alignItems:"center"}}>Open<ChevronDown   onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave} strokeWidth={2} absoluteStrokeWidth  size={18}  color="rgba(255,114,94,0.7)" style={{padding:"2px",cursor:"pointer"}}/> 
           </div>:""}</div>
 
{itemId==item?.contentID?flattenedDataChapter?.length?flattenedDataChapter?.map((itemChapter, indexChapter) => 
        (<div  index={indexChapter} key={itemChapter?.ID} style={{margin:"0px",marginTop:"10px",padding:"0px",paddingLeft:"0px",background:"#ffffff"}}   >
{itemChapter?.postType=="folder"? <BatchFolderContent contentDripArr={contentDripArr}  item={itemChapter} closePopUp={()=>{ setOpenFolderContentPopUp(false)}} />
:itemChapter?.postType=="chapter"?<div  className="courseContentItemOuterHeadActiveSettings" style={{margin:"10px",marginTop:"0px",padding:"10px",paddingLeft:"10px",background:"#ffffff"}} >
<div className="courseContentItemJustifyContentIcons">{ itemChapter?.postType=="folder"?<img     src={contentfolder} 
        alt="selected Img"
   style={{cursor:"pointer",width:"25px",height:"25px"
    
   }}/>:visibility=="public"?
   itemChapter?.postType=="chapter"?<Film  onMouseEnter={handleMouseEnter}
             onMouseLeave={handleMouseLeave} strokeWidth={2} absoluteStrokeWidth  size={18} 
   color="rgba(144, 202, 249,1)" style={{padding:"5px",background:"rgba(144, 202, 249,0.1)",borderRadius:"5px",cursor:"pointer",cursor: 'move',}}/> :<div></div>:<div></div>}
   
 </div><div className="courseContentItemJustifyContent"> <div className="themeNone "
 style={{fontSize:"15px",color:"#111",fontWeight:"700"}}> 
  {itemChapter?.menuOrder}:  {itemChapter?.postType=="folder"?"Folder":itemChapter?.postType=="chapter"?"Chapter":""} -  {itemChapter?.Name}
 
      </div><div>
 <DripItemFields drip={getDripItem(item?.ID, contentDripArr)} />
 </div></div><div  className="courseContentItemOuterHeadActiveSettingsInnTwo"
         style={{fontSize:"10px",color:"#222",fontWeight:"800"}}>
            <div   style={{padding:"5px",background:"rgba(144, 202, 249,0.1)",fontSize:"14px",padding:"5px 10px",display:"flex",
            justifyContent:"center",alignItems:"center",gap:"5px",
                borderRadius:"5px",cursor:"pointer"}} onClick={()=>{setCurrentItem(itemChapter);setCurrentDripItem(getDripItem(itemChapter?.ID, contentDripArr));
                                setCurrentDripItemStatus(true)}}>{getDripItem(itemChapter?.ID, contentDripArr)?<span className="hideXsForApp">Update  </span>:<span className="hideXsForApp">Add  </span>}
                                 Drip</div>  
{itemChapter?.postType=="chapter"?"":<div  onClick={()=>{setCurrentFolder(itemChapter);setOpenFolderContentPopUp(true)}}>
      <Pencil 
   onMouseEnter={handleMouseEnter}
             onMouseLeave={handleMouseLeave} strokeWidth={2} absoluteStrokeWidth  size={18} 
   color="#222" style={{padding:"4px",background:"rgba(144, 202, 249,0.1)",height:"18px",
    fontSize:"13px",borderRadius:"5px",color:"#222",borderRadius:"5px",cursor:"pointer"}}/>
    </div> }
    
        
         </div>
         {currentChapterID==itemChapter?.contentID?
         <div  onClick={()=>{ fireGetAllContentssByChapterId(itemChapter?.contentID);setCurrentChapterId("");;setOpenContentInFolder(false)}}
          style={{width:"50px",marginLeft:"-10px",background:"#ffffff",display:"flex",padding:"5px",borderRadius:"5px",justifyContent:"space-between",alignItems:"center",cursor:"pointer"}}>Close<ChevronUp 
            onMouseEnter={handleMouseEnter}
           onMouseLeave={handleMouseLeave} strokeWidth={2} absoluteStrokeWidth  size={18}  color="rgba(255,114,94,0.7)" style={{padding:"2px",cursor:"pointer"}}/> 
         </div> :<div onClick={()=>{
               fireGetAllContentssByChapterId(itemChapter?.contentID);setCurrentChapterId(itemChapter?.contentID);setOpenContentInFolder(true)
             }}  style={{width:"50px",marginLeft:"-10px",background:"#ffffff",display:"flex",padding:"5px",borderRadius:"5px",cursor:"pointer",
         justifyContent:"space-between",alignItems:"center"}}>Open<ChevronDown   onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave} strokeWidth={2} absoluteStrokeWidth  size={18}  color="rgba(255,114,94,0.7)" style={{padding:"2px",cursor:"pointer"}}/> 
           </div> } 
            
      
 </div>:""}
 
 <div  >
  {openContentInFolder&&currentChapterID==itemChapter?.contentID?flattenedDataChapterInn?.length?flattenedDataChapterInn?.map((itemFF, indexFF) => 
        (<div  index={indexFF} key={itemFF?.ID}    >
 <BatchFolderContent contentDripArr={contentDripArr}  item={itemFF} closePopUp={()=>{ setOpenFolderContentPopUp(false)}} /></div>)):"":""} </div>  </div> )):flattenedDataLoadingChapter?.length==0?flattenedDataChapter?.length?"":<div align="center"style={{margin:"15px",padding:"10px",borderRadius:"15px",background:"rgba(255,114,94,0.1)"}}><h3 style={{"textAlign":"center",
       
}}> Opps... <span className="coloredTextV1">No Chapter Found !!!</span>    </h3>

</div>: <div>
         
         <div  className="chapterContentItemGridOuter" style={{margin:"10px",minHeight:"40px",marginTop:"10px",paddingLeft:"10px",background:"#ffffff"}}>
         <div className="text-linetw "  style={{marginTop:"0px",marginRight:"10px",height:"25px",width:"54%",paddingLeft:"10px",padding:"5px"}}>
    
    </div> <div className="text-linetw "  style={{marginTop:"0px",marginRight:"10px",height:"25px",width:"54%",paddingLeft:"10px",padding:"5px"}}>
    
   </div><div  className="text-linetw" style={{marginTop:"0px",height:"25px",width:"94%",paddingLeft:"10px",padding:"5px"}}>
</div><div  className="courseContentItemOuterHeadActiveSettingsInnTwo"
   style={{fontSize:"10px",color:"#222",fontWeight:"800"}}>
     <div className="text-linetw "  style={{marginTop:"0px",marginRight:"10px",height:"25px",width:"74%",paddingLeft:"10px",padding:"5px"}}>
    
    </div>  <div className="text-linetw "  style={{marginTop:"0px",marginRight:"10px",height:"25px",width:"54%",paddingLeft:"10px",padding:"5px"}}>
    
    </div><div className="text-linetw "  style={{marginTop:"0px",marginRight:"10px",height:"25px",width:"54%",paddingLeft:"10px",padding:"5px"}}>
    
    </div></div>
     </div><div  className="chapterContentItemGridOuter" style={{margin:"10px",minHeight:"40px",marginTop:"10px",paddingLeft:"10px",background:"#ffffff"}}>
         <div className="text-linetw "  style={{marginTop:"0px",marginRight:"10px",height:"25px",width:"54%",paddingLeft:"10px",padding:"5px"}}>
    
    </div> <div className="text-linetw "  style={{marginTop:"0px",marginRight:"10px",height:"25px",width:"54%",paddingLeft:"10px",padding:"5px"}}>
    
   </div><div  className="text-linetw" style={{marginTop:"0px",height:"25px",width:"94%",paddingLeft:"10px",padding:"5px"}}>
</div><div  className="courseContentItemOuterHeadActiveSettingsInnTwo"
   style={{fontSize:"10px",color:"#222",fontWeight:"800"}}>
     <div className="text-linetw "  style={{marginTop:"0px",marginRight:"10px",height:"25px",width:"74%",paddingLeft:"10px",padding:"5px"}}>
    
    </div>  <div className="text-linetw "  style={{marginTop:"0px",marginRight:"10px",height:"25px",width:"54%",paddingLeft:"10px",padding:"5px"}}>
    
    </div><div className="text-linetw "  style={{marginTop:"0px",marginRight:"10px",height:"25px",width:"54%",paddingLeft:"10px",padding:"5px"}}>
    
    </div></div>
     </div>
</div>:""}
 </div></>:""}
   {item?.postType=="folder"?currentChapterID==item?.contentID? 
        (<div    > 
     <BatchFolderContent contentDripArr={contentDripArr}  item={item} closePopUp={()=>{ setOpenFolderContentPopUp(false)}} />
    </div>):"":""}
</div>)):"":""}












{flattenedDataLoading?flattenedDataLoading?.map((item, index) => 
        (<div  index={index} key={item?.ID}    >

            <div
className={"posRelative"  }
             style={{ margin:"10px",background:"rgba(144, 202, 249,0.1)",marginTop:"15px",padding:"10px",
                marginRight:"15px",position:"relative",borderRadius:"10px",overflow:"hidden",boxShadow:"0 7px 20px 0 rgba(1,1,1,0.021)"}} 
          
             
            >
         
         <div  className="chapterContentItemGridOuter" style={{margin:"0px",marginTop:"-20px",paddingLeft:"10px",background:"transparent"}}>
         <div className="text-linetw "  style={{marginTop:"10px",marginRight:"10px",height:"35px",width:"54%",paddingLeft:"10px",padding:"5px"}}>
    
    </div> <div className="text-linetw "  style={{marginTop:"10px",marginRight:"10px",height:"35px",width:"54%",paddingLeft:"10px",padding:"5px"}}>
    
   </div><div  className="text-linetw" style={{marginTop:"10px",height:"35px",width:"94%",paddingLeft:"10px",padding:"5px"}}>
</div><div  className="courseContentItemOuterHeadActiveSettingsInnTwo"
   style={{fontSize:"10px",color:"#222",fontWeight:"800"}}>
     <div className="text-linetw "  style={{marginTop:"10px",marginRight:"10px",height:"35px",width:"74%",paddingLeft:"10px",padding:"5px"}}>
    
    </div>  <div className="text-linetw "  style={{marginTop:"10px",marginRight:"10px",height:"35px",width:"54%",paddingLeft:"10px",padding:"5px"}}>
    
    </div><div className="text-linetw "  style={{marginTop:"10px",marginRight:"10px",height:"35px",width:"54%",paddingLeft:"10px",padding:"5px"}}>
    
    </div></div>
    </div>
    <div  className="chapterContentItemGridOuter" style={{margin:"0px",minHeight:"40px",marginTop:"10px",paddingLeft:"10px",background:"#ffffff"}}>
         <div className="text-linetw "  style={{marginTop:"0px",marginRight:"10px",height:"25px",width:"54%",paddingLeft:"10px",padding:"5px"}}>
    
    </div> <div className="text-linetw "  style={{marginTop:"0px",marginRight:"10px",height:"25px",width:"54%",paddingLeft:"10px",padding:"5px"}}>
    
   </div><div  className="text-linetw" style={{marginTop:"0px",height:"25px",width:"94%",paddingLeft:"10px",padding:"5px"}}>
</div><div  className="courseContentItemOuterHeadActiveSettingsInnTwo"
   style={{fontSize:"10px",color:"#222",fontWeight:"800"}}>
     <div className="text-linetw "  style={{marginTop:"0px",marginRight:"10px",height:"25px",width:"74%",paddingLeft:"10px",padding:"5px"}}>
    
    </div>  <div className="text-linetw "  style={{marginTop:"0px",marginRight:"10px",height:"25px",width:"54%",paddingLeft:"10px",padding:"5px"}}>
    
    </div><div className="text-linetw "  style={{marginTop:"0px",marginRight:"10px",height:"25px",width:"54%",paddingLeft:"10px",padding:"5px"}}>
    
    </div></div>
     </div></div></div>)):""}

      {flattenedDataLoading?.length==0?flattenedData?.length?"": <div align="center"style={{margin:"15px",padding:"10px",borderRadius:"15px",background:"rgba(255,114,94,0.1)"}}><h3 style={{"textAlign":"center",
       
    }}> Opps... <span className="coloredTextV1">No Section Found !!!</span>     </h3>
    <h5>
       </h5>
    </div>:""}
</div>




</div>
  
           











    

      
    

   {currentDripItemStatus&&currentItem?.ID?<BatchLeftPopup
       setCurrentDripItemStatus={()=>{ setCurrentDripItemStatus(false)}}
       contentDripArr={contentDripArr}
       currentDripItemStatus={currentDripItemStatus}
      currentItem={currentItem}
        currentDripItem={currentDripItem}
        onClose={()=>{setCurrentDripItem("")}}
        onAdded={()=>{}}
      />:""}

        
        </div></>)
}
export default BatchSections;

